import { useEffect, useState } from 'react';
import { fetchDeployStatus, type DeployStatus } from './api';

// How often the console re-checks deploy status. The BFF caches AWS describe calls
// for ~10s, so polling faster than that just hits the cache; 15s is plenty for an
// operator-facing banner.
const POLL_MS = 15_000;

// Polls /bff/deploy-status while mounted. Best-effort: a failed poll keeps the last
// known status (the banner is advisory — a transient error must not flap it). Returns
// null until the first successful fetch.
export function useDeployStatus(): DeployStatus | null {
  const [status, setStatus] = useState<DeployStatus | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async (): Promise<void> => {
      try {
        const next = await fetchDeployStatus();
        if (!cancelled) setStatus(next);
      } catch {
        // Keep the previous status; the next poll will refresh it.
      }
    };
    void load();
    const timer = setInterval(() => void load(), POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return status;
}
